import { useCallback, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./AthletePoll.module.css";

import NBLogo from "../components/NBLogo";
import ProgressBar from "../components/ProgressBar";
import NavPanel from "../components/NavPanel";
import NBLogoWhite from "../components/NBLogoWhite";


const AthletePoll = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1)
  const [cocoGrow, setCocoGrow] = useState(false);
  const [tommyGrow, setTommyGrow] = useState(false);

  const sleep = ms => new Promise(r => setTimeout(r, ms));

  const onGoBackClick = useCallback(() => {
    navigate("/");
  }, [navigate]);
  const onGoNextClick = useCallback(() => {
    navigate("/coco-trivia");
  }, [navigate]);


  const onCocoClick = useCallback(async () => {
    setStep(2);
    document.getElementsByClassName('tommy')[0].hidden = true;
    setCocoGrow(true);
    await sleep(1500);
    navigate("/coco-trivia");
  }, [navigate]);

  const onTommyClick = useCallback(async () => {
    setStep(2);
    document.getElementsByClassName('coco')[0].hidden = true;
    setTommyGrow(true);
    await sleep(1500);
    navigate("/tommy-trivia");
  }, [navigate]);

  return (
    <div className={styles.intro}>
      <NavPanel postion='right' onClick={onGoNextClick} />
      <NavPanel onClick={onGoBackClick} />
      { (cocoGrow || tommyGrow)  &&
        (
          <div className={styles.player}>
            { cocoGrow &&  <img className={styles.cocoImage} src='coco_trivia.png'></img> }
            { tommyGrow &&  <img className={styles.cocoImage} src='tommy_trivia.png'></img> }
            <div className={styles.gradient}></div>
            <NBLogoWhite />

          </div>
        )
      }

      <div className={styles.frameParent}>
        <div className={ `${styles.question} ${cocoGrow || tommyGrow ? styles.hiding : ''}`}>
          <NBLogo/>
          <div className={styles.caption}>
            Who best complements <br/> your game?
          </div>
        </div>

        <div className={styles.cardPicker}>
          <div
            className={`coco ${styles.card} ${styles.full} ${cocoGrow ? styles.cocoGrow : ""}`}
            onClick={onCocoClick}
          >
            <img src={'coco.jpg'} className={styles.athleteImg} onLoad={(e) => { e.target.classList.add(styles.athleteZoomIn) }}></img>
            <div className={styles.name}> Coco Gauff</div>
          </div>

          <div className={`tommy ${styles.card} ${styles.full} ${tommyGrow ?  styles.grow : ''} `}
            onClick={onTommyClick}>
            <img src={'tommy.jpg'} className={styles.athleteImg} onLoad={(e) => { e.target.classList.add(styles.athleteZoomIn) } }></img>
            <div className={styles.name}>Tommy Paul</div>
          </div>
        </div>
      </div>
      <ProgressBar current={step} />
    </div>
  );
};

export default AthletePoll;
